import * as React from 'react';
import VoxelText from '../Text/VoxelText';
import { ReactElement } from 'react';
import { FontAwesomeIconProps } from '@fortawesome/react-fontawesome';

export interface VoxelDialogTitleProps {
  textColor?: string;
  title?: string;
  titleIcon?: ReactElement<FontAwesomeIconProps>;
}

const VoxelDialogTitle: React.FC<VoxelDialogTitleProps> = ({
  children,
  textColor,
  title,
  titleIcon,
}) => {
  return (
    <div className="pt-8 pb-2 px-8 flex flex-row items-center gap-3">
      {!!titleIcon && titleIcon}
      <VoxelText variant={'title2'} colorClassName={textColor}>
        {title}
      </VoxelText>
    </div>
  );
};

export default VoxelDialogTitle;
